import type * as React from 'react';
import { AttentionList, KitBarChart, KitDonutChart, KpiCard, OverviewLayout } from '@redhand/ui';
import { demoAttention, demoOrderStates, demoWeekSales } from '../../demo-data.js';

const severityLabels = { info: 'Info', warning: 'Pozor', critical: 'Kritické' } as const;

/** Vzorova obrazovka: ciselny Prehled (Kokpit/Fakturace archetyp dle reference). */
export function PrehledSample(): React.JSX.Element {
  return (
    <OverviewLayout
      title="Přehled prodejů"
      periodPicker={<button type="button" className="rh-btn">27. 1. 2026 – 6. 2. 2026</button>}
      kpis={
        <>
          <KpiCard
            icon={<span>🧾</span>}
            label="Tržby"
            value="145 500 Kč"
            delta={{ value: '12,25 %', direction: 'up', srLabel: 'nárůst o 12,25 % proti minulému období' }}
            caption="proti minulému týdnu"
          />
          <KpiCard
            icon={<span>🧮</span>}
            label="Průměrná objednávka"
            value="1 250 Kč"
            delta={{ value: '10 %', direction: 'up', srLabel: 'nárůst o 10 %' }}
            caption="proti minulému týdnu"
          />
          <KpiCard
            icon={<span>👥</span>}
            label="Zákazníci"
            value="650"
            delta={{ value: '8 %', direction: 'up', srLabel: 'nárůst o 8 %' }}
            caption="proti minulému týdnu"
          />
          <KpiCard
            icon={<span>📦</span>}
            label="Prodané kusy"
            value="450"
            delta={{ value: '2,5 %', direction: 'down', srLabel: 'pokles o 2,5 %' }}
            caption="proti minulému týdnu"
          />
        </>
      }
      charts={
        <div className="rh-card">
          <h2 style={{ margin: '0 0 12px', fontSize: 16 }}>Tržby po dnech</h2>
          <KitBarChart
            ariaLabel="Tržby po dnech, toto a minulé období"
            data={demoWeekSales}
            xKey="day"
            series={[
              { key: 'current', label: 'Toto období' },
              { key: 'previous', label: 'Minulé období' },
            ]}
            height={300}
          />
        </div>
      }
      aside={
        <>
          <div className="rh-card">
            <h2 style={{ margin: '0 0 12px', fontSize: 16 }}>Stavy objednávek</h2>
            <KitDonutChart ariaLabel="Rozložení stavů objednávek" data={demoOrderStates} centerValue="436" centerLabel="objednávek" />
          </div>
          <div className="rh-card">
            <h2 style={{ margin: '0 0 8px', fontSize: 16 }}>Upozornění</h2>
            <AttentionList ariaLabel="Upozornění" severityLabels={severityLabels} items={demoAttention.slice(0, 2)} />
          </div>
        </>
      }
    />
  );
}
